export default {
  computed: {
    requiredFuseBoxModules() {
      if (!this.$store.state.configurations.requiredFuseBoxes) return [];

      return this.$store.state.configurations.requiredFuseBoxes
        .map(fuseBox => {
          const module = this.$store.state.modules.find(module => fuseBox.itemNo == module.itemNumber)
          if (!module) throw new Error("No module found for fuse box")
          return {
            ...module,
            description: module.description,
            category: module.medium,
            type: module.type
          }
        });
    }
  }
}
